import * as angular from "angular";
import {StateService} from "./modules/commons/services/state.service";
import {isIgnoredTransitionError} from "./modules/commons/utils/transition-error.util";

angular
  .module('app')
  .run(runFunction);

/* @ngInject */
function runFunction($rootScope, $state, $window, UserService, stateService: StateService) {

  // default redirect if access is denied
  function redirectError(event, toState, toParams, fromState, fromParams, error) {
    if (isIgnoredTransitionError(error)) {
      return;
    }
    if (!UserService.getCurrentUser()) {
      // $state.go('authentication.login');
    } else {
      $state.go('500');
    }
  }

  // redirect all errors to 500
  const errorHandle = $rootScope.$on('$stateChangeError', redirectError);

  if ($window.addEventListener) {
    $window.addEventListener('unhandledrejection', function (event) {
      if (isIgnoredTransitionError(event.reason)) {
        event.preventDefault();
      }
    });
  }

  // States that are never a meaningful "where the user was headed" - excluded so a
  // login attempt (successful or not) can never persist one of these as the place to
  // redirect back to afterward.
  const excludedFromPreviousState = [
    'authentication.login', 'authentication.reset', 'authentication.forgot',
    'sso-login', 'sso-silent-refresh'
  ];

  $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
    if (excludedFromPreviousState.indexOf(toState.name) === -1) {
      stateService.setPreviousState(toState.name);
      stateService.setPreviousStateParams(toParams);
    }
  });

  // remove watch on destroy
  $rootScope.$on('$destroy', function () {
    errorHandle();
  });

}
